import { defineMessages } from 'react-intl';

export default defineMessages({
    type: {
        id: 'ml.quoteandbind.pupexcludedwatercrafts.type',
        defaultMessage: 'Type'
    },
    year: {
        id: 'ml.quoteandbind.pupexcludedwatercrafts.year',
        defaultMessage: 'Year'
    },
    make: {
        id: 'ml.quoteandbind.pupexcludedwatercrafts.make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'ml.quoteandbind.pupexcludedwatercrafts.model',
        defaultMessage: 'Model'
    },
    excluded: {
        id: 'ml.quoteandbind.pupexcludedwatercrafts.excluded',
        defaultMessage: 'Excluded'
    }
});
